import React from 'react';

export const BriefCase = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M1.17822 8.80737L8.17822 10.9074L15.1782 8.80737"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M1.17822 4.60742H15.1782V15.1074H1.17822V4.60742Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M11.6782 4.60742V4.46742C11.6782 2.61174 10.1739 1.10742 8.31822 1.10742H8.03822C6.18254 1.10742 4.67822 2.61174 4.67822 4.46742V4.60742"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
